import {
  createDocument,
  updateDocument,
  deleteDocument,
  getDocument,
  getCollection,
} from "./FirebaseService.js";
import { createAxcelerateContact } from "./AxcelerateService";
import 'react-toastify/dist/ReactToastify.css';
import { CIET_URL } from "../constants.js";

import axios from "axios";
import { auth } from "../auth/firebase.js";
import { functionsURL } from "./AxcelerateService.js";
const COLLECTION = "enrollments";
const mapFormStateToEnrollment = (state, enrolmentReferenceId, category) => ({
  studentId: state.personal?.studentId || "",        // replace with your internal mapping
  cietStudentId: state.personal?.cietStudentId || "",
  enrolmentReferenceId: enrolmentReferenceId || "",
  agentId: state.campusCourse?.agentId || null,
  campusCourseId: state.campusCourse?.campusCourseId || "",
  intakeId: state.intake?.intakeId || "",
  visaId: state.visa?.visaId || "",
  languageCultureId: state.languageCulture?.languageCultureId || "",
  disabilityId: state.disability?.disabilityId || "",
  schoolingQualificationId: state.schoolingQualifications?.schoolingQualificationId || "",
  oshcId: state.oshc?.oshcId || "",
  employmentStudyReasonId: state.employmentStudyReason?.employmentStudyReasonId || "",
  additionalServiceId: state.additionalServices?.additionalServiceId || "",
  rplCreditId: state.rplCredit?.rplCreditId || "",
  usiId: state.usi?.usiId || "",
  declarationId: state.declaration?.declarationId || "",
  status: "pending",
  category: category,
  migratedToStudentSystem: false,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
});
const mapEnrollment = (state, enrolmentReferenceId, category) => ({
  studentId: state.personal?.studentId || "",        // replace with your internal mapping
  cietStudentId: state.personal?.cietStudentId || "",
  enrolmentReferenceId: enrolmentReferenceId || "",
  formState: state || {},
  category: category,
  status: "pending",
  migratedToStudentSystem: false,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
});
const mapFormStateToUpdateEnrollment = (state, enrolmentReferenceId, category) => ({
  enrolmentReferenceId: enrolmentReferenceId || "",
  formState: state || {},
  category: category || "international",
  updatedAt: new Date().toISOString(),
});
const mapFormStateToEnrolmentApplication = (initialData, enrolmentApplicationForm, enrolmentReferenceId) => ({
  studentId: initialData.formState.personal?.studentId || "",        // replace with your internal mapping
  cietStudentId: initialData.formState.personal?.cietStudentId || "",
  enrolmentReferenceId: enrolmentReferenceId || "",
  formState: initialData.formState || {},
  enrolmentApplicationForm: enrolmentApplicationForm || {},
  status: initialData.status,
  category: initialData.category || "international",
  migratedToStudentSystem: initialData.migratedToStudentSystem,
  updatedAt: new Date().toISOString(),
});

export const createEnrollment = async (data, referenceId, id, category) =>
  await createDocument(COLLECTION, mapFormStateToEnrollment(data, referenceId, category), id);
export const createStateEnrollment = async (data, referenceId, id, category) =>
  await createDocument(COLLECTION, mapEnrollment(data, referenceId, category), id);

export const updateEnrollment = async (id, data, enrolmentReferenceId, category) =>
  await updateDocument(COLLECTION, id, mapFormStateToUpdateEnrollment(data, enrolmentReferenceId, category));

export const updateEnrollmentApplicationForm = async (id, data, enrolmentApplicationForm, enrolmentReferenceId) =>
  await updateDocument(COLLECTION, id, mapFormStateToEnrolmentApplication(data, enrolmentApplicationForm, enrolmentReferenceId));

export const acceptEnrollment = async (id, studentId) => {
  if (!id) throw new Error("Enrollment ID is required");
  return await updateDocument(COLLECTION, id, { status: "accepted", enrolmentAcceptedAt: new Date().toISOString() , studentId: studentId});
};

export const shiftEnrollmentToAccelerate = async (id, initialData) => {
  if (!id) throw new Error("Enrollment ID is required");
  if (initialData.axcelerateContactID) return initialData.axcelerateResponse;

  let createAxAPIResponse = {
    type: "error",
    message: "Failed to create Axcelerate contact for enrollment",
    axcelerateContactID: 0
  };

  if (initialData) {
    try {
      const initialDataFromStorage = await getEnrollment(id);
      if (initialDataFromStorage.axcelerateContactID) {
        return {
          type: "success",
          message: `Successfully created Axcelerate contact ID: ${initialDataFromStorage.axcelerateContactID}`,
          axcelerateContactID: initialDataFromStorage.axcelerateContactID
        };
      };
      const axcelerateResponse = await createAxcelerateContact("", initialData);
      const contactId = axcelerateResponse?.CONTACTID;

      if (contactId) {
        createAxAPIResponse = {
          type: "success",
          message: `Successfully created Axcelerate contact ID: ${contactId}`,
          axcelerateContactID: contactId
        };
        await updateDocument(COLLECTION, initialData.id, {
          migratedToStudentSystem: true,
          axcelerateContactID: contactId,
          axcelerateURL: `${CIET_URL}/management/management2/contact_View.cfm?contactID=${contactId}`,
          axcelerateResponse: createAxAPIResponse,
          updatedAxcelerateAt: new Date().toISOString()
        });
        createAxAPIResponse = {
          type: "success",
          message: `Successfully created Axcelerate contact ID: ${contactId}`,
          axcelerateContactID: contactId
        };
      } else {
        createAxAPIResponse = {
          type: "warn",
          message: "Axcelerate response missing CONTACTID, Reason: " + (axcelerateResponse?.response?.data?.error.DETAILS || "Unknown error")
        };
        await updateDocument(COLLECTION, initialData.id, {
          axcelerateResponse: createAxAPIResponse
        });
      }

    } catch (error) {
      createAxAPIResponse = {
        type: "error",
        message: `Failed to create Axcelerate contact: ${error.details}`
      };
      await updateDocument(COLLECTION, initialData.id, {
        axcelerateResponse: createAxAPIResponse
      });
    }
  }
  // Return structured status for UI to display toasters
  return createAxAPIResponse;
};

export const updateEnrollmentToAccelerate = async (id, contactId, initialData) => {
  if (!id) throw new Error("Enrollment ID is required");

  let dbUpdate = {
    type: "error",
    message: "Failed to create Axcelerate contact for enrollment"
  };

  if (initialData) {
    try {
      const initialDataFromStorage = await getEnrollment(id);
      const axcelerateUpdateResponse = await createAxcelerateContact(contactId, initialDataFromStorage);
      const axcelerateContactId = axcelerateUpdateResponse?.contactUpdate?.CONTACTID;

      if (axcelerateContactId) {
        dbUpdate = {
          type: "success",
          message: `Successfully created Axcelerate contact ID: ${axcelerateContactId}`
        };
        await updateDocument(COLLECTION, initialData.id, {
          migratedToStudentSystem: true,
          axcelerateContactID: axcelerateContactId,
          axcelerateURL: `${CIET_URL}/management/management2/contact_View.cfm?contactID=${axcelerateContactId}`,
          axcelerateResponse: dbUpdate,
          updatedAxcelerateAt: new Date().toISOString()
        });
      } else {
        dbUpdate = {
          type: "warn",
          message: "Axcelerate response missing CONTACTID, Reason: " + (axcelerateUpdateResponse?.response?.data?.error.DETAILS || "Unknown error")
        };
        await updateDocument(COLLECTION, initialData.id, {
          axcelerateResponse: dbUpdate
        });
      }

    } catch (error) {
      dbUpdate = {
        type: "error",
        message: `Failed to create Axcelerate contact: ${error.details}`
      };
      await updateDocument(COLLECTION, initialData.id, {
        axcelerateResponse: dbUpdate
      });
    }
  }
  // Return structured status for UI to display toasters
  return dbUpdate;
};


export const lockEnrolmentData = async (id) => {
  if (!id) throw new Error("Enrollment ID is required");
  return await updateDocument(COLLECTION, id, { status: "locked", lockedAt: new Date().toISOString() });
};

export const deleteEnrollment = async (id) =>
  await deleteDocument(COLLECTION, id);

export const getEnrollment = async (id) => await getDocument(COLLECTION, id);

export const getAllEnrollments = async () => {
  const enrolments = await getCollection(COLLECTION);
  return enrolments;
}

export const convertPDF = async (filledDoc) => {
  const formData = new FormData();
  formData.append(
    "docx",
    filledDoc instanceof Blob ? filledDoc : new Blob([filledDoc], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" }),
    "form.docx"
  );

  const user = auth.currentUser;
  if (!user) throw new Error("User not signed in");

  const token = await user.getIdToken();

  const response = await axios.post(
    `${functionsURL}/api/convert`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob", // 👈 ensures you get a PDF blob, not JSON
    }
  );

  // Wrap into a Blob
  const pdfBlob = new Blob([response.data], { type: "application/pdf" });

  return pdfBlob;
};

